/**
 * Which onboarding candidates match what HR typed.
 *
 * Matches on name, email, phone, vertical and designation, so "sales", a
 * surname or the last digits of a number all find the person. Every word must
 * match somewhere ("ravi sales" is Ravi in Sales), in any order.
 */
export function filterCandidates(candidates, query) {
  const list = Array.isArray(candidates) ? candidates : [];
  const words = String(query || '')
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return list;
  return list.filter((user) => {
    const haystack = [
      user?.name,
      user?.email,
      user?.phone_number,
      user?.vertical,
      user?.designation?.name
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return words.every((word) => haystack.includes(word));
  });
}
